import { useQuery } from "@tanstack/react-query";
import { ExportXlsx } from "../export-xlsx";

export const useExportCoupon = (filter: string) => {
  const { refetch } = useQuery({
    queryKey: ["Export"],
    queryFn: () => ExportXlsx("coupons", filter),
    enabled: false,
  });

  return { refetch };
};
